export class CommissionPromoterAdditional {

  public commissionId?:number;

  public businessProductId?:number;
  public businessProductDescr?:string;

  public ownerTypeId?:number;
  public ownerTypeDescr?:string;

  public productosCOEId?:number;
  public productosCOEDescr?:string;

  public afiliateId?:string;
  public afiliateDescr?:string;

  public paymentId?:number;
  public paymentDescr?:string;

  public employeeJobId?:number;
  public employeeJobDescr?:string;

  public commission?:number;
  public commissionMax?:number;

  public collectCapitalAmountMin?:number;
  public collectCapitalAmountMax?:number;

  // public employeeId?:string;
  // public creditId?:string;

  public createUserId?:number;
  public createUserName?:string;
  public createDate?:string;

  public modifUserId?:number;
  public modifUserName?:string;
  public modifDate?:string;

  public activeId?:boolean;

  public selected?:boolean;

}
